import { render, staticRenderFns } from "./DisplayDrawing.vue?vue&type=template&id=6b6d0c0c"
import script from "./DisplayDrawing.vue?vue&type=script&lang=js"
export * from "./DisplayDrawing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports